import { render, staticRenderFns } from "./expandItem.vue?vue&type=template&id=00c1ece4&scoped=true"
import script from "./expandItem.vue?vue&type=script&lang=js"
export * from "./expandItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c1ece4",
  null
  
)

export default component.exports